import { SelectChangeEvent } from '@mui/material';
import { EIdentifiedTypeLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/enums';
import CustomSelect from '../CustomSelect/CustomSelect';
import { ICustomSelectProps } from '../types';
import React from 'react';
import { getConfigIdentifiedTypeLinkManagement } from '@organisms/Tables/Enterprise/LinksManagementTable/utils';
import { MenuItemStyled } from '@molecules/Filters/styles';

interface ILinkManagementSourceTypeSelectProps extends ICustomSelectProps {}

const LinkManagementSourceTypeSelect = ({
  savedDataSelectedRow,
  setSavedDataSelectedRow,
  handleClose,
  customSxForSelect,
  ...props
}: ILinkManagementSourceTypeSelectProps) => {
  const handleOnChange = (event: SelectChangeEvent<unknown>) => {
    event.stopPropagation();
    setSavedDataSelectedRow({
      ...savedDataSelectedRow,
      identifiedType: Number(event.target.value as EIdentifiedTypeLinkManagement),
    });
  };

  return (
    <CustomSelect
      listData={EIdentifiedTypeLinkManagement}
      title="Identified type:"
      handleOnChange={handleOnChange}
      handleClose={handleClose}
      customSxForSelect={customSxForSelect}
      {...props}
    >
      {Object.entries(EIdentifiedTypeLinkManagement).map(([, identifiedType]) => {
        const config = getConfigIdentifiedTypeLinkManagement(
          identifiedType as EIdentifiedTypeLinkManagement,
        );
        return (
          <MenuItemStyled key={identifiedType} value={identifiedType}>
            {config?.identifiedType}
          </MenuItemStyled>
        );
      })}
    </CustomSelect>
  );
};

export default React.memo(LinkManagementSourceTypeSelect);
